// note: the values must be lower case
export const SEARCH_BY_NAME = 'name';
export const SEARCH_BY_CITY = 'city';
export const SEARCH_BY_LOCATION = 'location';
export const SEARCH_BY_STATE = 'state';
export const SEARCH_BY_COUNTY = 'county';
export const SEARCH_BY_ZIP = 'zip';
export const SEARCH_BY_CEEB = 'ceeb';
export const SEARCH_BY_COUNTRY = 'country';

export const SEARCH_CATEGORY_SELECTED = 'SEARCH_CATEGORY_SELECTED';
